import { useCallback, useState } from "react";
const useElementAttribute = (attribute) => {
  const [value, setValue] = useState(null);
  const getAttribute = useCallback((element) => {
    setValue(element == null ? void 0 : element.getAttribute(attribute));
  }, [attribute]);
  return [value, getAttribute];
};
var useElementAttribute_default = useElementAttribute;
export {
  useElementAttribute_default as default
};
